module.exports = "https://static.wmbcdn.com/uniweb/images/81573d9dd645dfb70861cba4e5e2f05a.svg";